module.exports = __webpack_public_path__ + "img/applicationConstruction-wlwsjdj.f8631007.png";